import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import { CourseStep } from '../models/course';

export const createLinkStep = (
  courseId: string,
  stepName: string,
  stepDescription: string,
  order: number,
  linkUrl: string,
  stepType: 'link' | 'zoom' | 'myWSBLink',
  initiatingUserId: string
): Promise<CourseStep> => {
  const taskTypeMap = {
    link: 'Link',
    zoom: 'Link',
    myWSBLink: 'MyWSBLink',
  } as const;
  const taskId = uuid.generate();
  return submitCommand(
    courseId,
    {
      id: courseId,
      initiatingUserId: initiatingUserId,
      task: {
        _id: { id: taskId },
        taskName: stepName,
        taskDescription: stepDescription,
        linkUrl: linkUrl,
        order: order,
        _type: taskTypeMap[stepType],
      },
    },
    'AddTaskToTaskList',
    'TaskAddedToTaskList',
    'TaskListError'
  ).then(() => ({
    _id: { id: taskId },
    _type: taskTypeMap[stepType],
    taskName: stepName,
    order,
  }));
};
